import {useRef} from "react";

export function useSwipeAction(
    onTap: () => void,
    onSwipe: () => void,
    threshold = 35
) {
    const startX = useRef(0);
    const startY = useRef(0);
    const endX = useRef(0);
    const endY = useRef(0);

    const onTouchStart = (e: React.TouchEvent) => {
        const t = e.touches[0];
        startX.current = t.clientX;
        startY.current = t.clientY;
        endX.current = t.clientX;
        endY.current = t.clientY;
    };

    const onTouchMove = (e: React.TouchEvent) => {
        const t = e.touches[0];
        endX.current = t.clientX;
        endY.current = t.clientY;
    };

    const onTouchEnd = () => {
        const dx = endX.current - startX.current;
        const dy = endY.current - startY.current;

        const distance = Math.sqrt(dx * dx + dy * dy);

        if (distance >= threshold) {
            onSwipe();
        } else {
            onTap();
        }
    };

    return {onTouchStart, onTouchMove, onTouchEnd};
}
